import { ActionIcon, CopyButton, Tooltip } from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";

export default function CopyIdButton({ value }) {
  return (
    <CopyButton value={value} timeout={2000}>
      {({ copied, copy }) => (
        <Tooltip
          withArrow
          position="left"
          label={copied ? `Copied!` : `Copy ID: ${value}`}
          color={copied ? "green" : "dark"}
        >
          <ActionIcon
            color={copied ? "green" : "blue"}
            variant="subtle"
            onClick={(e) => {
              e.stopPropagation();
              copy();
            }}
          >
            {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
          </ActionIcon>
        </Tooltip>
      )}
    </CopyButton>
  );
}
